import GoogleSignInButton from './SigninButtonGoogle'
import SignInButtonOIDC from './SigninButtonOIDC'


interface SigninPanelProps {
    authError?: Error
    redirectTo: string
}

export default function SigninPanel({ authError, redirectTo }: SigninPanelProps) {

    return (
        <div className="flex flex-col">
            <div className='flex mt-10 items-center flex-col'>
                <GoogleSignInButton redirectTo={redirectTo} />
                <SignInButtonOIDC redirectTo={redirectTo} providerId="oidc.amazon-federate" label="Login with Amazon Federate"/>
            </div>
            {
                authError &&
                <div className="mt-8 text-center">
                    <div className='text-slate-900 dark:text-slate-200'>
                        Sorry, we have not been able to sign you in.<br />
                        Please try again or contact support@vertesiahq.com if it persists.
                        <pre className="mt-2">Error: {authError.message}</pre>
                    </div>
                </div>

            }

        </div>
    )
}
